// event related unstable prefixes
// don't import this file directly, import '$unstable/prefixes'

export const MATRIX_SABLE_UNSTABLE_MESSAGE_FORWARD_META_PROPERTY_NAME = 'moe.sable.message.forward';
